import { Button } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import { localeDate } from "../../../app/datetimeUtils";
import PrintDownloadMenu from "../../../components/PrintDownloadMenu";

interface TableRightSideHeaderProps {
	lastUpdated?: Date;
	hasData: boolean;
	hideRows?: boolean;
	setHideRows?: (hide: boolean) => void;
	hideLabel?: string;
	uniqueKey: string;
	printLabel?: string;
	downloadExcelLink: string;
	downloadCsvLink: string;
}

export function TableRightSideHeader({
	lastUpdated,
	hasData,
	hideRows,
	setHideRows,
	hideLabel,
	uniqueKey,
	printLabel,
	downloadExcelLink,
	downloadCsvLink,
}: TableRightSideHeaderProps) {
	function handlePrint() {
		window.print();
	}

	return (
		<div className={`flex-shrink-0 ${setHideRows ? "" : "flex gap-x-3 items-end -mt-3"}`}>
			<p className="text-xs text-right mb-2">
				Last Updated: {localeDate(lastUpdated ?? new Date())}
			</p>
			{hasData && (
				<div className="flex flex-col items-end print:hidden">
					<div className="flex gap-2 items-center justify-end">
						{setHideRows && (
							<Button
								id="hide-table"
								className="btn btn-neutral"
								onClick={() => setHideRows(!hideRows)}>
								<span className="flex items-center">
									{hideRows ? (
										<>
											<PlusIcon className="size-4 mr-2" /> Show{" "}
											{hideLabel ?? "Rows"}
										</>
									) : (
										<>
											<MinusIcon className="size-4 mr-2" /> Hide{" "}
											{hideLabel ?? "Rows"}
										</>
									)}
								</span>
							</Button>
						)}

						<PrintDownloadMenu
							uniqueKey={uniqueKey}
							printLabel={printLabel ?? "Table"}
							onPrint={handlePrint}
							downloadExcelLink={downloadExcelLink}
							downloadCsvLink={downloadCsvLink}
						/>
					</div>
				</div>
			)}
		</div>
	);
}
